import { api } from "@/lib/api";

const CHUNK = 4 * 1024 * 1024;

// Uploads a file in 4 MB pieces to `${path}?index=&total=&mime=` (+ extra query), returns the last response.
export async function uploadChunks(path, file, onProgress, extra = "") {
  const total = Math.ceil(file.size / CHUNK);
  let last = null;
  for (let i = 0; i < total; i += 1) {
    last = await api.post(`${path}?index=${i}&total=${total}&mime=${encodeURIComponent(file.type)}${extra}`,
      file.slice(i * CHUNK, (i + 1) * CHUNK), { headers: { "Content-Type": "application/octet-stream" } });
    onProgress(Math.round(((i + 1) / total) * 100));
  }
  return last?.data;
}
